/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ContractItem } from '@/ContractConfig';
import { ContractFileType } from '@/enums/contract-type';
import { localPostLendingSpecialConfig } from './config';
import { getWisdomConfig } from '../wisdom';

export { PROCESS_TYPE } from './config';

/** 渠道定制化配置的协议类型 */
let postLendingSpecialConfigCache: Record<string, ContractFileType> | null = null;

/** 初始化贷后合同特殊配置，本地配置、中心配置合并 */
const initPostLendingSpecialConfig = async (): Promise<Record<string, ContractFileType>> => {
  if (!postLendingSpecialConfigCache) {
    const serviceConfig = await getWisdomConfig<Record<string, ContractFileType>>('postLendingContractConfig');

    postLendingSpecialConfigCache = {
      ...localPostLendingSpecialConfig,
      ...serviceConfig,
    };
  }

  return postLendingSpecialConfigCache;
};

export const getPostLendingContractFileType = async (
  commodityId: string,
  contractItems: ContractItem[],
): Promise<ContractItem[]> => {
  let loanContractItem: ContractItem[];

  const specialConfig = await initPostLendingSpecialConfig();
  const commoditySpecialConfig = specialConfig[commodityId];

  if (commoditySpecialConfig) {
    loanContractItem = contractItems.map((item) => ({
      ...item,
      fileType: commoditySpecialConfig,
    }));
  } else {
    loanContractItem = contractItems;
  }
  return loanContractItem;
};

/**
 * 通过链接后缀判断是否为pdf链接
 * @param url 链接
 * @returns 是否为pdf链接
 */
export const checkIfPdfLinkByExtension = (url: string): boolean => /\.pdf/i.test(url);
